<template lang="html">
  <div>
    <v-form v-model="formularioValido" ref="form">
      <v-container>

        <!-- Objetivos -->
        <v-layout row wrap justify-space-between>
          <v-flex xs12>
            <v-textarea
              label="Objetivos*"
              v-model="projetoPesquisa.objetivos"
              counter="2000"
              :rows="3"
              :auto-grow="true"
              :rules="[...obrigatorio,...max2000caracteres]"
              hint="Enumere os objetivos propostos para o projeto. Devem ser formulados com o tempo verbal no infinitivo, indicando uma ação."
            >
            </v-textarea>
          </v-flex>
        </v-layout>

        <!-- Metodologia -->
        <v-layout row wrap justify-space-between>
          <v-flex xs12>
            <v-textarea
              label="Metodologia*"
              v-model="projetoPesquisa.metodologia"
              counter="2000"
              :rows="3"
              :auto-grow="true"
              :rules="[...obrigatorio,...max2000caracteres]"
              hint="Deve explicitar como serão analisados os dados levantados, incluindo método da pesquisa, materiais e público-alvo, se for o caso."
            >
            </v-textarea>
          </v-flex>
        </v-layout>

        <!-- Principal Objetivo de Desenvolvimento Sustentável -->
        <v-layout row wrap justify-space-between>
          <v-flex xs12>
            <v-select
              label="Principal Objetivo de Desenvolvimento Sustentável*"
              :items="listaPrincipalODS"
              v-model="projetoPesquisa.principalODS"
              item-text="descricao"
              item-value="id"
              return-object
              :rules="obrigatorio"            
            ></v-select>
          </v-flex>
        </v-layout>

        <!-- Objetivo de Desenvolvimento Sustentável Afim -->
        <v-layout row wrap justify-space-between>
          <v-flex xs12>
            <v-select
              label="Objetivo de Desenvolvimento Sustentável Afim*"
              :items="listaODSAfim"
              v-model="projetoPesquisa.afimODS"
              item-text="descricao"
              item-value="id"
              return-object
              :rules="obrigatorio"
            ></v-select>
          </v-flex>
        </v-layout>

         <!-- Resultados esperados -->
        <v-layout row wrap justify-space-between>
          <v-flex xs12>
            <v-textarea
              label="Resultados esperados*"
              v-model="projetoPesquisa.resultadosEsperados"
              counter="2000"
              :rows="3"
              :auto-grow="true"
              :rules="[...obrigatorio,...max2000caracteres]"
              hint="Devem estar claras as metas que se deseja alcançar com o desenvolvimento desta pesquisa e as contribuições esperadas para a área do conhecimento."
            >
            </v-textarea>
          </v-flex>
        </v-layout>

        <br>

      </v-container>
    </v-form>

    <v-divider></v-divider>

    <v-card-actions>

      <!-- Botão "Cancelar" -->
      <v-btn color="primary" @click="cancelar()">Cancelar</v-btn>
      
      <v-spacer></v-spacer>
      
      <!-- Botão "Salvar" -->
      <v-btn color="primary" :disabled="!formularioValido" @click="editarProjetoPesquisa()">Salvar</v-btn>
    
    </v-card-actions>
  </div>
</template>

<script>
  import projetos from '@/utils/projetos'
  import BasicToolbar from '@/components/toolbars/basic-toolbar'
  import TextArea from '@/components/c-textarea'
  import { mapActions } from 'vuex'

  export default {
    props: ['idProjetoPesquisa'],
    data: () => ({
      formularioValido: false,
      projetoPesquisa: {
        objetivos: '',
        metodologia: '',
        resultadosEsperados: ''
      },
      listaPrincipalODS: [],
      listaODSAfim: [],
      obrigatorio: [v => !!v || 'Este campo é obrigatório'],
      max20caracteres: [v => v.length <= 20 || 'Este campo pode ter no máximo 20 caracteres'],
      max100caracteres: [v => v.length <= 100 || 'Este campo pode ter no máximo 100 caracteres'],
      max300caracteres: [v => v.length <= 300 || 'Este campo pode ter no máximo 300 caracteres'],
      max400caracteres: [v => v.length <= 400 || 'Este campo pode ter no máximo 400 caracteres'],
      max2000caracteres: [v => v.length <= 2000 || 'Este campo pode ter no máximo 2000 caracteres']
    }),
    methods: {
      ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),

      // Edita um projeto de pesquisa.
      editarProjetoPesquisa: function () {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Editando Projeto de Pesquisa...' })
        projetos.putProjetoPesquisa(this.idProjetoPesquisa, this.projetoPesquisa)
        .then(response => {
          this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: response.body.mensagem})
          this.$router.push({name: 'ProjetoPesquisaDetalhamento', params: {idProjetoPesquisa: this.idProjetoPesquisa}})
        })
        .catch(error => {
          this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Editando Projeto de Pesquisa...' })
        })
      },

      // Obtém classificações de acordo com o "classificacaoItem".
      obterClassificacoes: function (itemTabela, aqui, atributo) {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando classificação ' + atributo + '...' })
        projetos.getClassificacoesPossiveis(itemTabela)
        .then(response => {
          aqui[atributo] = response.data.slice()
        })
        .catch(error => {
          console.log('Erro ao mandar o request' + error)
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando classificação ' + atributo + '...' })
        })
      },

      // Redireciona para a tela de visualização da aba "Detalhamento" -->
      cancelar: function () {
        this.$router.push({name: 'ProjetoPesquisaDetalhamento', params: {idProjetoPesquisa: this.idProjetoPesquisa}})
      }
    },
    mounted () {
      // Carrega o projeto de pesquisa.
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto de pesquisa...' })
      projetos.getProjetoPesquisa(this.idProjetoPesquisa)
      .then(response => {
        this.projetoPesquisa = response.data
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto de pesquisa...' })
      })

      // Carrega a lista com os principais ODS (classificacaoItem = 103)
      this.obterClassificacoes(103, this, 'listaPrincipalODS')

      // Carrega a lista com os ODS afins (classificacaoItem = 104)
      this.obterClassificacoes(104, this, 'listaODSAfim')
    },
    components: {
      'basic-toolbar': BasicToolbar,
      'c-textarea': TextArea
    }
  }
</script>

<style lang="css">
  .menu {
    display: block !important;
  }

  .no-resize div textarea{
    resize: none;
  }
  .input-group__icon-cb {
    cursor: pointer !important;
  }

  .v-radio-group_label {
    margin-top: 0;
  }
</style>


// WEBPACK FOOTER //
// editar-detalhamento.vue?513aa66d